export default {
  Bulknotifications: {
    push: 'Push',
    pushListTitle: 'Wysłane powiadomienia push',
  },
};
